import { doc as docBuilder } from '@atlaskit/adf-utils/doc';
import { paragraph as p } from '@atlaskit/adf-utils/paragraph';
import { emptyAdfObject } from '@jira/issue__rich-content/src/emptyAdfObject.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const parseAdfString = (value: string | undefined): any => {
	if (!value) return emptyAdfObject;

	try {
		// case when value is string representation of a number
		if (!Number.isNaN(Number(value))) {
			return docBuilder(p(value));
		}

		return JSON.parse(value);
		// this catch is needed for old descriptions that were saved as primitive strings and cannot be parsed as a JSON
	} catch (e) {
		return docBuilder(p(value));
	}
};
